<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-danger">
            <p class="modal-card-title">{{$t('CANCELANDOCOLETA.CANCELARCOLETA')}}</p>
        </header>
        <section class="modal-card-body is-paddingless">
            <b-notification type="is-warning">
                <h5 class="is-size-5">{{$t('CANCELANDOCOLETA.ATENCAO')}}</h5>
                <p>{{$t('CANCELANDOCOLETA.CANCELARSELECIONADAS')}}</p>
            </b-notification>
            <b-notification v-if="erroCancelamentoColetaAmostra"
                            type="is-danger">
                {{ erroCancelamentoAmostra }}
            </b-notification>
            <div class="panel">
                <p class="panel-block">
                    <b-field :label="$t('CANCELANDOCOLETA.AMOSTRAS')">
                    </b-field>
                </p>
                <p class="panel-block">
                    <b-tag type="is-info" v-for="(amostra,index) in selecionada" :key="index">{{ amostra.codigoDeBarras }}</b-tag>
                </p>
                <p class="panel-block">
                    <b-field :label="$t('CANCELANDOCOLETA.MOTIVOS')">
                    </b-field>
                </p>
                <div class="panel-block">
                    <b-input v-model="procurarMotivosCancelamentoColetaAmostra"
                             icon="magnify"
                             icon-right="close-circle"
                             icon-right-clickable
                             @icon-right-click="procurarMotivosCancelamentoColetaAmostra = ''"></b-input>
                </div>
                <div class="panel-block">
                    <b-select multiple
                              native-size="10"
                              expanded
                              v-model="motivoCancelamentoColetaAmostraSelecionado">
                        <option v-for="(motivo,index) in filteredMotivosCancelamentoColetaAmostra" :key="index"
                                :value="motivo.id">
                            {{ motivo.descricaoInterno }}
                        </option>
                    </b-select>
                </div>

            </div>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-danger"
                      @click="confirmarCancelamentoColetaAmostra">{{$t('CANCELANDOCOLETA.CONFIRMARCANCELAMENTO')}}</b-button>
            <b-button @click="$emit('close')">{{$t('CANCELANDOCOLETA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    export default {
        props: {
            guia: Object,
            selecionada: Array
        },
        data() {
            return {
                procurarMotivosCancelamentoColetaAmostra: '',
                listaMotivosCancelamentoColetaAmostra: [],
                motivoCancelamentoColetaAmostraSelecionado: [],
                erroCancelamentoColetaAmostra: null,
            }
        },
        computed: {
            filteredMotivosCancelamentoColetaAmostra() {
                return this.procurarMotivosCancelamentoColetaAmostra
                    ? this.listaMotivosCancelamentoColetaAmostra
                        .filter(x =>
                            x.descricaoInterno
                                .toUpperCase()
                                .indexOf(this.procurarMotivosCancelamentoColetaAmostra.toUpperCase()) > -1)
                    : this.listaMotivosCancelamentoColetaAmostra
            },
        },
        mounted() {
            this.loadListaMotivosCancelamentoColetaAmostra();
        },
        methods: {
            loadListaMotivosCancelamentoColetaAmostra() {
                this.$http.get('/api/search/MotivosCancelamentoColetaAmostra')
                    .then(m => {
                        this.listaMotivosCancelamentoColetaAmostra = m.data
                    })
            },
            confirmarCancelamentoColetaAmostra() {
                 if(this.motivoCancelamentoColetaAmostraSelecionado == null || this.motivoCancelamentoColetaAmostraSelecionado.length == 0) {
                    return this.$buefy.toast.open({
                        duration: 5000,
                        message: this.$t('TOAST.MOTIVOCANCELAMENTO'),
                        type: 'is-warning'
                    })
                }


                this.$http.post('/api/atendimento/CancelarColetaAmostra', {
                    guiaId: this.guia.id,
                    id: this.selecionada.map(x => x.id),
                    motivoIds: this.motivoCancelamentoColetaAmostraSelecionado
                })
                    .then((res) => {
                        if (res.body.erro) {
                            this.erroCancelamentoColetaAmostra = res.body.erro
                        } else {
                            this.$emit('loadGuia')
                            this.$emit('close')
                        }
                    })
            },

        }
    }
</script>